import { apiGet, apiGetBlob, apiPost } from '@/api/http';

const apiUrl = import.meta.env.VITE_API_URL;

export const getEvents = (
  query = '',
  date_from = '',
  date_to = '',
  interview_id = '',
) => {
  let requestQuery = query;
  if (date_from) requestQuery += '&date_from=' + date_from;
  if (date_to) requestQuery += '&date_to=' + date_to;
  if (interview_id) requestQuery += '&interview_id=' + interview_id;
  return apiGet(`${apiUrl}events/?${requestQuery}`);
};

/**
 * Aggregated month feed: interview slots, action deadlines, candidate start
 * dates, and invoice due dates. Read straight from the live models, so it is
 * not limited to what the `Event` audit log happened to record.
 */
export const getCalendarFeed = (
  date_from: string,
  date_to: string,
  showColleagueInterviews = false,
) => {
  const params = new URLSearchParams({ date_from, date_to });
  if (showColleagueInterviews) {
    params.set('show_colleague_interviews', 'true');
  }
  return apiGet(`${apiUrl}calendar/?${params.toString()}`);
};

export const trackPageView = (page: string) =>
  apiPost(`${apiUrl}tracking/event/`, {
    event_type: 27,
    tag_name: page,
  });

export const trackChatClick = (interview: string) =>
  apiPost(`${apiUrl}tracking/event/`, {
    event_type: 27,
    tag_name: 'chat_with',
    interview_id: interview,
  });

export const trackJobSectionEvent = (
  feedback: number,
  job_id?: string,
  tag_name?: string,
) =>
  apiPost(`${apiUrl}tracking/event/`, {
    event_type: 32,
    tag_name,
    job_id,
    feedback: feedback.toString(),
  });

export const exportCalendarEvent = async (
  event_id: string,
  showColleagueInterviews = false,
) => {
  try {
    const query = showColleagueInterviews
      ? '?show_colleague_interviews=true'
      : '';
    return await apiGetBlob(`${apiUrl}events/${event_id}/export/ics/${query}`);
  } catch {
    return undefined;
  }
};
